import React from 'react'
import styled from 'styled-components'
import { Container, Row } from '../components' 
import MaterialIcon from 'material-icons-react'
import { useTranslation } from 'react-i18next'
import { FaInstagram, FaFacebook, FaYoutube } from 'react-icons/fa'

const BoxWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px 20px 20px;
  margin: 20px 0;
  width: 100%;
  box-sizing: border-box;
  
  @media (max-width: 768px) {
    flex-direction: column;
    margin: 20px 0;
  }
`

const LeftSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-weight: 900;
  font-size: 25px;
  color: #ec1c24;
  min-width: 360px;
  justify-content: flex-start;
  
  @media (max-width: 768px) {
    min-width: unset;
    margin-bottom: 20px;
  }
`

const RightSection = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  font-weight: 900;
  font-size: 25px;
  color: #ec1c24;
  min-width: 360px;
  justify-content: flex-end;

  @media (max-width: 768px) {
    min-width: unset;
  }
`

const Title = styled.h1`
  color: #b19961;
  font-size: 65px;
  font-weight: 400;
  text-align: center;
  margin: 0;
  
  @media (max-width: 768px) {
    font-size: 35px;
  }
`

const ContactDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  flex-grow: 1;  
  
  @media (max-width: 768px) {
    margin-bottom: 20px;
  }
`

const Box = styled.div`
  width: 200px;
  height: 200px;
  background-image: url(${require('assets/worldLogo.png')});
  background-size: cover;
  background-position: center;
  
  @media (max-width: 768px) {
    width: 150px;
    height: 150px;
  }
`

const Text = styled.p`
  font-weight: 200;
  font-size: 25px;
  color: #363535;
  margin: 0;
  
  @media (max-width: 768px) {
    font-size: 18px;
  }
`

const SocialIcons = styled.div`
  display: flex;
  margin-top: 20px;

  a {
    margin-right: 10px; 
    color: #b19961; 
    font-size: 32px; 
    transition: color 0.3s;

    &:hover {
      color: #ec1c24;
    }
  }
  
  @media (max-width: 768px) {
    font-size: 28px;
    margin-top: 15px;
  }
`

const TextLink = styled.a`
  text-decoration: none;  
  display: inline-block;
`

const Contact = () => {
  const { t } = useTranslation()

  return (
    <Container id='contact'>
      <BoxWrapper>
        <LeftSection>
          <Box />
        </LeftSection>
        
        <ContactDetails>
          <Title>{t('contact.title')}</Title>
          <Text>{t('home.titre')}</Text>
          <Text style={{ margin: '0 0 20px 0' }}>{t('home.countries')}</Text>
        </ContactDetails>

        <RightSection>
          <Row center>
            <MaterialIcon icon='email' size={32} color='#b19961' />
            <TextLink href='mailto:info@winnerbalkans.com'>
              <Text style={{ margin: '0 0 0 8px' }}>info@winnerbalkans.com</Text>
            </TextLink>
          </Row>
          <Row center>
            <MaterialIcon icon='phone' size={32} color='#b19961' />
            <TextLink href='tel:+38267351199'>
              <Text style={{ margin: '0 0 0 8px' }}>+382 67 351 199</Text>
            </TextLink>
          </Row>
          <Row center>
            <MaterialIcon icon='place' size={32} color='#b19961' />
            <Text style={{ margin: '0 0 0 8px' }}>Podgorica, Montenegro</Text>
          </Row>
          <SocialIcons>
            <a href='https://www.instagram.com/winneroptimist/' target='_blank' rel='noopener noreferrer'>
              <FaInstagram />
            </a>
            <a href='https://www.facebook.com/winneroptimist.dk' target='_blank' rel='noopener noreferrer'>
              <FaFacebook />
            </a>
            <a href='https://www.youtube.com/channel/UC45W8SMePaUeb_VmpE-i5EQ' target='_blank' rel='noopener noreferrer'>
              <FaYoutube />
            </a>
          </SocialIcons>
        </RightSection>
      </BoxWrapper>
    </Container>
  )
}

export default Contact
